import React from 'react'

export default function Error() {
  return (
    <>
        404 | There was a error accessing this page, check the URL
    </>
  )
}
